import React from "react";
var __jsx = React.createElement;
import { Container } from './SelectedBlockWrapper.style';

var SelectedBlockWrapper = function SelectedBlockWrapper(_ref) {
  var children = _ref.children,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? true : _ref$isSelected;
  return __jsx(Container, {
    isSelected: isSelected
  }, children);
};

export default SelectedBlockWrapper;